import React, { useState } from "react";
import FormField from "../../Components/FormField/FormField";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import SuperAnnButton from "../../Components/CheckableButton/SuperAnnButton";
import "./Tax.css";
import ReactTooltip from "react-tooltip";

const debtMessage = (
  <div>
    Do you have a Higher Education Loan Program (HELP), Student Start-up Loan
    (SSL) or Trade Support Loan (TSL) Debt?
    <HoverIcon
      icon="info circle"
      color="grey"
      text="If yes, ReadyTeacher will withhold additional amounts as per ATO advice"
    />
  </div>
);

function TaxForm(props) {
  // const user = props.user;

  // const [enterTFN, setEnterTFN] = useState();

  const handleTFNSelect = (e) => {
    if (e.target.value === "1") {
      // setEnterTFN(true);
      props.setEnterTFN(true);
    } else {
      // setEnterTFN(false);
      props.setEnterTFN(false);
    }
  };

  const handleResetTFN = (e) => {
    e.preventDefault();
    props.clearTFN();
  }

  return (
    <div className="row-sm">
      <div className="auth-text-top mb-5">
        <div className="row mt-5">
          <div className="col">
            <ButtonContainer
              horizontal
              className="TFNContainer"
              label="Tax File Number"
            >
              <CheckableButton
                className="TFNButton pr-6"
                id="tfn_select_1"
                name="tfn"
                value="1"
                required
                onChange={handleTFNSelect}
                checked={props.state.show_enter_tfn}
              >
                Enter your Australian Tax File Number (TFN)
              </CheckableButton>
              <label id="TFNOr"> OR </label>
              <CheckableButton
                className="TFNButton"
                id="tfn_select_2"
                name="tfn"
                value="2"
                required
                onChange={handleTFNSelect}
              >
                I have made a separate application to the ATO for a TFN
              </CheckableButton>
            </ButtonContainer>
            <div
              style={{ display: props.state.show_enter_tfn ? "flex" : "none" }}
              className='tfn-field'
            >
              <FormField
                id="tfn"
                style={{ margin: "0 20px" }}
                placeholder="Enter TFN"
                value={props.state.tfn}
                required={props.state.show_enter_tfn}
                onChange={props.handleFormFieldChange}
                disabled={props.state.enter_tfn_disabled}
              />
              <button
                  type='button'
                  className='btn btn-primary'
                  style={{ height: "34px" }}
                  onClick={handleResetTFN}>
                Clear
              </button>
            </div>

            <ButtonContainer id="taxCol1" label="Select Residence Status"
              header={
                <>
                  <i data-for='soclose' data-tip='To determine your resident status, please visit: ' class="grey info circle icon"></i>
                  <ReactTooltip id='soclose'
                    getContent={(dataTip) => 
                    <div><div>{dataTip} <a target="_blank" href="https://www.ato.gov.au/Calculators-and-tools/Work-out-your-tax-residency/">https://www.ato.gov.au/
                    Calculators-and-tools/Work-out-your-tax-residency/</a></div></div> }
                    effect='solid'
                    delayHide={500}
                    delayShow={500}
                    delayUpdate={500}
                    place={'top'}
                    className="custom-tooltip"
                    backgroundColor="rgb(47, 224, 222)"
                  />
                </>
              }
            >
              <CheckableButton
                className="residence"
                id="tax_type_1"
                name="residence_status"
                required
                onChange={props.handleRadioChange}
                checked={
                  props.state.residence_status ===
                  "An Australian resident for tax purposes"
                }
              >
                An Australian resident for tax purposes
              </CheckableButton>
              <CheckableButton
                className="residence"
                id="tax_type_2"
                name="residence_status"
                required
                onChange={props.handleRadioChange}
                checked={
                  props.state.residence_status ===
                  "A foreign resident for tax purposes"
                }
              >
                A foreign resident for tax purposes
              </CheckableButton>
              <CheckableButton
                className="residence"
                id="tax_type_3"
                name="residence_status"
                required
                onChange={props.handleRadioChange}
                checked={
                  props.state.residence_status === "A working holiday maker"
                }
              >
                A working holiday maker
              </CheckableButton>
            </ButtonContainer>
          </div>
          <div className="col ml-1">
            <ButtonContainer
              twoColumns
              className=""
              label="Do you want to claim the tax-free threshold from ReadyTeacher?"
              horizontal
            >
              <CheckableButton
                className="mr-4"
                id="threshold_y"
                name="tax_threshold"
                required
                onChange={props.handleRadioChange}
                checked={props.state.tax_threshold}
              >
                Yes
              </CheckableButton>
              <CheckableButton
                className="mr-4"
                id="threshold_n"
                name="tax_threshold"
                required
                onChange={props.handleRadioChange}
                checked={props.state.tax_threshold === false}
              >
                No
              </CheckableButton>
            </ButtonContainer>
            <ButtonContainer
              twoColumns
              className=""
              label={debtMessage}
              horizontal
            >
              <CheckableButton
                className="mr-4"
                id="loan_y"
                name="has_loan"
                required
                onChange={props.handleRadioChange}
                checked={props.state.has_loan}
              >
                Yes
              </CheckableButton>
              <CheckableButton
                className="mr-4"
                id="loan_n"
                name="has_loan"
                required
                onChange={props.handleRadioChange}
                checked={props.state.has_loan === false}
              >
                No
              </CheckableButton>
            </ButtonContainer>
            <ButtonContainer
              twoColumns
              className=""
              label="Do you have a financial supplement debt?"
              header={
                <HoverIcon
                  icon="info circle"
                  color="grey"
                  text="If yes, ReadyTeacher will withhold additional amounts as per ATO advice"
                />
              }
              horizontal
            >
              <CheckableButton
                className="mr-4"
                id="debt_y"
                name="has_debt"
                required
                onChange={props.handleRadioChange}
                checked={props.state.has_debt}
              >
                Yes
              </CheckableButton>
              <CheckableButton
                className="mr-4"
                id="debt_n"
                name="has_debt"
                required
                onChange={props.handleRadioChange}
                checked={props.state.has_debt === false}
              >
                No
              </CheckableButton>
            </ButtonContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TaxForm;
